import { ExternalConnectionsProviders } from '@griply/types';

const providerNameKeys: Record<ExternalConnectionsProviders, string> = {
  [ExternalConnectionsProviders.Google]: 'calendar.providers.google',
  [ExternalConnectionsProviders.Outlook]: 'calendar.providers.outlook',
};

export const getProviderNameKey = (
  provider: ExternalConnectionsProviders,
): string => providerNameKeys[provider];
